import React, { useState } from "react";
import { Button, Plus } from "@opendate-app/setlist";
import BreadcrumbChevron from "../../shared/components/BreadcrumbChevron";
import CollectionsNavIcon from "../../shared/Icons/CollectionsNavIcon";
import ContainerlessTableViewApp from "../../TableView/startup/ContainerlessTableViewApp";
import TeamSearchBar from "../../TeamManager/components/TeamSearchBar";
import NewCollectionModal from "./NewCollectionModal";
import { useCollectionsIndexContext } from "../CollectionsIndexApp";

const EMPTY_STATES = {
  active: ["No collections yet", "Group different events, like a festival or a weekend takeover, so you can sell and promote them together."],
  archived: ["No archived collections", "Collections you archive will show up here."],
};

const CollectionsIndex = () => {
  const {
    teamId,
    createPath,
    activeCount,
    archivedCount,
    canCreateCollection,
    venueOwnerships,
    activeTab,
    setActiveTab,
    searchTerm,
    setSearchTerm,
    dataSource,
    columns,
    rowCallback,
  } = useCollectionsIndexContext();
  const [newCollectionOpen, setNewCollectionOpen] = useState(false);

  const counts = { active: activeCount, archived: archivedCount };
  const [emptyTitle, emptyText] = EMPTY_STATES[activeTab];
  const newCollectionButton = canCreateCollection && (
    <Button variant="primary" className="series-index-new-btn" icon={Plus} onClick={() => setNewCollectionOpen(true)}>
      New collection
    </Button>
  );

  return (
    <div className="series-index-page">
      <nav aria-label="breadcrumb" className="mb-3">
        <div className="d-flex align-items-center flex-wrap series-index-breadcrumb">
          <a href="/dashboard" className="settings-breadcrumb-link" aria-label="Home">
            <i className="fal fa-home" />
          </a>
          <BreadcrumbChevron />
          <a href="/dashboard" className="settings-breadcrumb-link">Calendar</a>
          <BreadcrumbChevron />
          <span className="settings-breadcrumb-current">Collections</span>
        </div>
      </nav>

      <div className="mb-3 d-flex align-items-start justify-content-between series-index-title-row">
        <div>
          <h1 className="series-index-title">Collections</h1>
          <p className="series-index-subtitle">
            Festivals, takeovers, and other sets of different events, grouped in one place.
          </p>
        </div>
        {newCollectionButton}
      </div>

      {canCreateCollection && (
        <NewCollectionModal
          open={newCollectionOpen}
          onClose={() => setNewCollectionOpen(false)}
          createPath={createPath}
          teamId={teamId}
          venueOwnerships={venueOwnerships || []}
        />
      )}

      <div className="d-inline-flex series-index-tabs" role="tablist">
        {[["active", "Active"], ["archived", "Archived"]].map(([tab, label]) => {
          const selected = activeTab === tab;
          return (
            <button
              key={tab}
              type="button"
              role="tab"
              aria-selected={selected}
              onClick={() => setActiveTab(tab)}
              className={`d-inline-flex align-items-center series-index-tab ${selected ? "series-index-tab-selected" : ""}`}
            >
              <span>{label}</span>
              <span className={`series-index-tab-count ${selected ? "series-index-tab-count-selected" : ""}`}>
                {counts[tab]}
              </span>
            </button>
          );
        })}
      </div>

      {counts[activeTab] === 0 ? (
        <div className="team-member-card">
          <div className="team-empty-state">
            <div className="team-empty-state-icon">
              <CollectionsNavIcon className="" size={48} />
            </div>
            <div className="team-empty-state-title">{emptyTitle}</div>
            <div className="team-empty-state-text">{emptyText}</div>
            {activeTab === "active" && newCollectionButton && (
              <div className="team-empty-state-actions">{newCollectionButton}</div>
            )}
          </div>
        </div>
      ) : (
        <div className="team-member-card">
          <div className="team-search-filters-row">
            <div className="team-search-filters-left">
              <TeamSearchBar searchTerm={searchTerm} onSearchChange={setSearchTerm} placeholder="Search collections..." />
            </div>
          </div>
          <ContainerlessTableViewApp
            key={`collections-${activeTab}-${searchTerm}`}
            dataSource={dataSource}
            columns={columns}
            order={[[2, activeTab === "archived" ? "desc" : "asc"]]}
            rowCallback={rowCallback}
          />
        </div>
      )}
    </div>
  );
};

export default CollectionsIndex;
